export const completeFormErrorMessage = 'Please complete change address details form';

/**
 * API Has one format.. our form fields have another
 * SHAZAM.. I map from API format to react hook form fields format
 */
export const mapAddressToFields = (address) => ({
  addressId: address.AddressId,
  deliveryAddress1: address.Street1,
  deliveryAddress2: address.Street2 || '',
  suburb: address.Suburb,
  postcode: address.Postcode,
  state: address.State,
  stateDescription: address.StateDescription,
  stateId: address.StateId,
  country: address.CountryDescription,
  countryId: address.CountryId,
});

const mapAddressToAPI = (address) => {
  const baseResult = {
    Street1: address.deliveryAddress1,
    Street2: address.deliveryAddress2 || null,
    Suburb: address.suburb,
    Postcode: address.postcode,
    StateId: address.stateId,
    State: address.state,
    StateDescription: address.stateDescription,
    CountryId: address.countryId,
    CountryDescription: address.country,
    ShippingMethod: 0,
    FullAddress: null,
    ErrorMessage: null,
  };

  if (address.addressId) {
    // if this address already exists in the CRM include extra data
    return {
      ...baseResult,
      AddressId: address.addressId,
      AddressLine3: null,
      PrimaryIndicator: false,
      ToBeDeleted: false,
    };
  }

  return baseResult;
};

export const mapFieldsToAPI = (fields) => ({
  PrimaryAddress: mapAddressToAPI(fields),
  SecondaryAddresses: fields.secondary.map((a) => mapAddressToAPI(a)),
});

export const setValuesOnAddresses = (response, setValue) => {
  const mappedResponse = mapAddressToFields(response.PrimaryAddress);
  setValue('addressId', mappedResponse.addressId);
  setValue('deliveryAddress1', mappedResponse.deliveryAddress1);
  setValue('deliveryAddress2', mappedResponse.deliveryAddress2);
  setValue('suburb', mappedResponse.suburb);
  setValue('postcode', mappedResponse.postcode);
  setValue('state', mappedResponse.state);
  setValue('stateId', mappedResponse.stateId);
  setValue('stateDescription', mappedResponse.stateDescription);
  setValue('country', mappedResponse.country);
  setValue('countryId', mappedResponse.countryId);
  setValue(
    'secondary',
    response.SecondaryAddresses.map((secondaryAddress) => mapAddressToFields(secondaryAddress))
  );
};
